import React from 'react';
import { Button } from '@insurancemenu/imenu-components-lib';
import FormsSpinner from 'components/common/FormSpinner';
import { createStyles } from './styles';

export interface SignedInContentWrapperProps {
  content: JSX.Element;
  isValidToContinue: boolean;
  sessionLoading?: boolean;
  onContinue: () => void;
  onLogout: () => void;
}

const SignedInContentWrapper = ({
  content,
  isValidToContinue,
  sessionLoading = false,
  onContinue,
  onLogout,
}: SignedInContentWrapperProps): JSX.Element => {
  const classes = createStyles();

  return (
    <>
      <FormsSpinner display={sessionLoading} />
      {content}
      <div className={classes.buttonsWrapper}>
        <Button size="large" type="outlined" className={classes.button} onClick={onLogout}>
          Logout
        </Button>
        <Button
          size="large"
          color="primary"
          className={classes.button}
          disabled={!isValidToContinue}
          onClick={onContinue}
        >
          Continue
        </Button>
      </div>
    </>
  );
};

export default SignedInContentWrapper;
